import AdBar from './AdBar';

export default AdBar;
